module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/detail_doctor01-278ba8cade5d04dd32e75ec2b9751a3b.png";